export const LocaleHelper = {
  async getLV1ListInt(country: string): Promise<{ code: string; name: string }[]> {
    const countryStateList = (await import('./../data/countries-states.json')).default;
    //console.log('data', countryStateList, country);
    return (countryStateList.find((c) => c.iso2 === country)?.states || []).map((c) => ({
      code: c.state_code,
      name: c.name,
    }));
  },

  async getLV1List(): Promise<{ code: string; name: string }[]> {
    return (await import('./../data/vi-lv1.json')).default;
  },
  async getLV2List(lv1Code: string): Promise<{ code: string; name: string }[]> {
    const lv12Prefer: any = (await import('./../data/vi-lv12-prefer.json')).default;
    if (lv12Prefer[lv1Code]) return lv12Prefer[lv1Code];

    const lv12All: any = (await import('./../data/vi-lv12.json')).default;
    return lv12All[lv1Code] || [];
  },

  async getLV3List(lv2Code: string): Promise<{ code: string; name: string }[]> {
    const lv23Prefer: any = (await import('./../data/vi-lv23-prefer.json')).default;
    if (lv23Prefer[lv2Code]) return lv23Prefer[lv2Code];

    const lv23All: any = (await import('./../data/vi-lv23.json')).default;
    return lv23All[lv2Code] || [];
  },
};
